module.exports = __webpack_public_path__ + "static/img/nodata.c1c94437.png";